// We need a function that converts every letter to capitals execept the letters i, u and a which should always be lowercase.
// It should take in a string and return a string. It should respect spaces and special characters.
// If the letters i, u or a are uppercase, they should be converted to lowercase.
// It should keep html tags as they are.
// Ensure the character comparison is case-insensitive.
// Example:

// letterConversion("Hello World") => "HELLO WORLD
// letterConversion("I am a student") => "i aM a STuDENT

export function convertLetters(input: string): string {
    // Convert all text to uppercase for the Vanderheim font
    return input.toUpperCase();
}

export function convertLettersSafely(input: string | null | undefined): string {
    if (!input) return "";
    return input.toUpperCase();
}
